import Helper from "./Helper";
import System from "src/helper/system";

export const ADMIN_USER_LAST_LOGIN_DATE_SEARCH_KEY = 'lastLoginDate';
export const ADMIN_USER_LAST_LOGIN_DATE_SEARCH_LEGACY_LABEL = 'Last Login Date';
export const ADMIN_USER_LAST_LOGIN_DATE_SEARCH_LABEL = 'Last Log in Date (Since)';
export const ADMIN_USER_LAST_LOGIN_DATE_SEARCH_TOOLTIP = 'Results will show all users that have logged in since the selected date.';
export const ADMIN_USER_LAST_LOGIN_DATE_SEARCH_REQUEST_FIELD = 'LastLoginFromDate';
export const ADMIN_USER_LAST_LOGIN_DATE_SEARCH_ALLOWED_MONTHS = 36;

const ADMIN_USER_LAST_LOGIN_DATE_SEARCH_LABELS = [
    ADMIN_USER_LAST_LOGIN_DATE_SEARCH_LABEL,
    ADMIN_USER_LAST_LOGIN_DATE_SEARCH_LEGACY_LABEL
];

const hasMatchingSearchType = (searchType, expectedSearchType) => {
    return typeof searchType === 'string' &&
        searchType.trim().toLowerCase() === expectedSearchType.trim().toLowerCase();
};

const getLocalDateOnly = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

const getMonthEndDate = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
};

const addMonthsClamped = (date, monthOffset) => {
    const targetMonthIndex = date.getMonth() + monthOffset;
    const targetYear = date.getFullYear() + Math.floor(targetMonthIndex / 12);
    const targetMonth = ((targetMonthIndex % 12) + 12) % 12;
    const targetDate = Math.min(date.getDate(), getMonthEndDate(targetYear, targetMonth));

    return new Date(targetYear, targetMonth, targetDate);
};

export const getAdminUserLastLoginDateSearchRange = (referenceDate = new Date()) => {
    const today = getLocalDateOnly(referenceDate);

    return {
        minDate: addMonthsClamped(today, -ADMIN_USER_LAST_LOGIN_DATE_SEARCH_ALLOWED_MONTHS),
        maxDate: today
    };
};

export const shouldDisableAdminUserLastLoginDate = (date) => {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
        return true;
    }

    const selectedDate = getLocalDateOnly(date);
    const { minDate, maxDate } = getAdminUserLastLoginDateSearchRange();

    return selectedDate < minDate || selectedDate > maxDate;
};

export const isAdminUserLastLoginDateSearchEnabled = () => {
    return System.isAdminUserLastLoginDateSearchEnabled();
};

export const isLastLoginDateSearchType = (searchType) => {
    return ADMIN_USER_LAST_LOGIN_DATE_SEARCH_LABELS.some((label) => hasMatchingSearchType(searchType, label));
};

export const getAdminUserLastLoginDateSearchLabel = (searchType) => {
    return isLastLoginDateSearchType(searchType) ? ADMIN_USER_LAST_LOGIN_DATE_SEARCH_LABEL : searchType;
};

export const sanitizeAdminUserFilterList = (filterList = []) => {
    const safeFilterList = Array.isArray(filterList) ? filterList.filter(Boolean) : [];

    if (isAdminUserLastLoginDateSearchEnabled()) {
        return safeFilterList;
    }

    return safeFilterList.filter((filterItem) => !isLastLoginDateSearchType(filterItem?.searchType));
};

export const sanitizeAdminAccountFilterList = (filterList = {}) => {
    const safeFilterList = filterList && !Array.isArray(filterList) ? { ...filterList } : {};

    if (isAdminUserLastLoginDateSearchEnabled()) {
        return safeFilterList;
    }

    delete safeFilterList[ADMIN_USER_LAST_LOGIN_DATE_SEARCH_KEY];

    return safeFilterList;
};

export const getLastLoginFromDateValue = (value) => {
    if (typeof value !== 'string' || value.trim() === '') {
        return null;
    }

    return value.split('T')[0];
};

export const getAdminUserLastLoginValue = (item = {}) => {
    if (!item || typeof item !== 'object') {
        return null;
    }

    return Helper.valueIsNotNull(item?.lastLoginDate) ? item.lastLoginDate : null;
};

export const getFormattedAdminUserLastLoginValue = (item = {}) => {
    const lastLoginValue = getAdminUserLastLoginValue(item);

    return lastLoginValue ? Helper.getDatepickerFormatAdminConsole(lastLoginValue) : "";
};
